<template>
  <div class="about_us"></div>
</template>

<script>
export default {
  name: "About_Us",
};
</script>
